import React, { useEffect, useCallback } from 'react';
import { Button, Checkbox, FormControlLabel, TextField } from '@mui/material';
import './reqMessage.scss';
//REDUX
import ACTIONS from '../../../../redux/action';
import { useSelector, useDispatch } from 'react-redux';
import ReqSentCherry from '../reqSent/reqSentCherry';
import ContactInfo from '../contactInfo/contactInfo.jsx';
import i18n from '../../../../utils/i18n.js';
import sendreqpic from '../../../../images/sendreqpic.png';
import { gdprLabelSF } from '../../data/searchFlowText.js';

const ReqMessage = ({ data, ...props }) => {
	const [emailError, setEmailError] = React.useState(false);
	const [nameError, setNameError] = React.useState(false);
	const [phoneError, setPhoneError] = React.useState(false);
	const [gdprError, setGdprError] = React.useState(false);
	const [showReqSent, setShowReqSent] = React.useState(false);
	const [reqMsg, setReqMsg] = React.useState('');

	const dispatch = useDispatch();
	const companyStore = useSelector((state) => state.company_store);

	const validateInput = useCallback(() => {
		const validEmailRegex = RegExp(
			// eslint-disable-next-line no-useless-escape
			/^(([^<>()\[\]\.,;:\s@\']+(\.[^<>()\[\]\.,;:\s@\']+)*)|(\'.+\'))@(([^<>()[\]\.,;:\s@\']+\.)+[^<>()[\]\.,;:\s@\']{2,})$/i
		);
		return validEmailRegex.test(companyStore.email);
	}, [companyStore.email]);

	useEffect(() => {
		setReqMsg(companyStore.reqMessage);
		window.scrollTo(0, 0);
		if (emailError && validateInput()) {
			setEmailError(false);
		}
		if (gdprError && companyStore.gdpr) {
			setGdprError(false);
		}
		if (phoneError && companyStore.companyPhone.length > 6) {
			setPhoneError(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		companyStore.gdpr,
		validateInput,
		companyStore.companyPhone.length,
		emailError,
		gdprError,
		phoneError,
	]);

	const handleChange = (event) => {
		setReqMsg(event.target.value);
	};

	//console.log(data, 'DATA IN SENDREQCHERRY');

	return (
		<React.Fragment key='reqmessage'>
			{showReqSent ? (
				<ReqSentCherry handleClose={props.handleClose} />
			) : (
				<div className='ReqMessagePaper'>
					<div className='ReqMessageHeader'>
						<img alt='send rfp' src={sendreqpic} className='sendrfp' />
						<p>{i18n.t('searchflow.reqmsgtitle')}</p>
					</div>
					<div style={{ padding: '0 16px' }}>
						<div className='ReqMessageText'>
							<h2>{i18n.t('searchflow.reqmessagelabel')}</h2>
						</div>
						<div>
							<ContactInfo
								emailError={emailError}
								phoneError={phoneError}
								gdprError={gdprError}
								nameError={nameError}
							/>
						</div>
						<div>
							<p className='ReqMessageLength'>
								<span>{i18n.t('searchflow.reqmsg')}:</span>{' '}
								<span>({reqMsg.length}/1500)</span>
							</p>
							<TextField
								id='outlined-multiline-static'
								multiline
								rows={4}
								value={reqMsg}
								onChange={(e) => {
									e.stopPropagation();
									handleChange(e);
								}}
								onBlur={(event) =>
									dispatch(
										ACTIONS.addCompanyInfo({
											id: 'reqMessage',
											data: event.target.value,
											stateObject: 'company_store',
										})
									)
								}
								inputProps={{ maxLength: 1500 }}
							/>
							<div style={{ marginTop: '12px' }}>
								<FormControlLabel
									key={'marketing'}
									control={
										<Checkbox
											id='marketing'
											name='checked'
											checked={companyStore.marketing}
											onChange={(event) => {
												dispatch(
													ACTIONS.addCompanyInfo({
														id: event.target.id,
														data: event.target.checked,
														stateObject: 'company_store',
													})
												);
											}}
											color='primary'
											/*    disabled={this.state.submitted} */
										/>
									}
									label={
										<span className='SFSmallText'>
											{i18n.t('searchflow.newslettersubtext')}
										</span>
									}
								/>
								<FormControlLabel
									key={'gdpr'}
									control={
										<Checkbox
											id='gdpr'
											name='gdpr'
											checked={companyStore.gdpr}
											onChange={(event) => {
												dispatch(
													ACTIONS.addCompanyInfo({
														id: event.target.id,
														data: event.target.checked,
														stateObject: 'company_store',
													})
												);
											}}
											color='primary'
											required
											/*  disabled={this.state.submitted} */
										/>
									}
									label={gdprLabelSF()}
								/>
							</div>
							{props.gdprError ? (
								<span
									style={{
										color: 'red',
										fontSize: '14px',
										fontWeight: 'bold',
									}}>
									{i18n.t('searchflow.plsacceptgdpr')}
								</span>
							) : null}

							<div className='SpaceBetween MarginHorizontal'>
								<Button onClick={props.handleClose}>
									<p
										style={{
											color: '#1a00bd',
											margin: 0,
											textTransform: 'none',
										}}>
										{i18n.t('general.backbutton')}
									</p>
								</Button>
								<Button
									className='ReqMsgSend'
									onClick={() => {
										if (companyStore.email.length === 0 || !validateInput()) {
											setEmailError(true);
										}
										if (!companyStore.gdpr) {
											setGdprError(true);
										}
										if (companyStore.companyPhone.length < 6) {
											setPhoneError(true);
										}
										if (
											(companyStore.gdpr &&
												companyStore.email.length !== 0 &&
												companyStore.companyPhone.length === 0 &&
												validateInput()) ||
											(companyStore.gdpr &&
												companyStore.email.length !== 0 &&
												companyStore.companyPhone.length > 6 &&
												validateInput())
										) {
											let reqData = Object.assign({}, companyStore);
											reqData.selected_providers = [
												...companyStore.selected_providers,
												data,
											];
											dispatch(
												ACTIONS.addProviderToRequest({
													data: reqData.selected_providers,
												})
											);
											console.log(reqData, 'REQDATA');
											if (props.reqID.length === 0) {
												props.createRequest(reqData);
												setShowReqSent(true);
											}
											if (props.reqID.length > 0) {
												props.updateRequest(reqData);
												props.handleClose();
											}
										}
									}}>
									<p
										style={{
											color: 'white',
											margin: 0,
											textTransform: 'none',
										}}>
										{i18n.t('general.send')}
									</p>
								</Button>
							</div>
						</div>
					</div>
				</div>
			)}
		</React.Fragment>
	);
};

export default ReqMessage;
